export default function mobileMenu() {
    return {
        isOpen: false,
        active: null,

        toggleMenu() {
            this.isOpen = !this.isOpen;
            document.body.style.overflow = this.isOpen ? 'hidden' : '';
        },

        closeMenu() {
            this.isOpen = false;
            this.active = null;
            document.body.style.overflow = '';
        },
    }
}
